var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('strong',[_vm._v("Por medio de pago")]),_c('v-card',{staticClass:"elevation-0",staticStyle:{"height":"100%"},attrs:{"loading":_vm.loading,"max-height":"320px"}},[_c('Doughnut',{attrs:{"id":"recaudo-chart","options":_vm.chartOptions,"data":_vm.chartData}})],1),_c('h5',[_vm._v("Ventas por medio de pago")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }